// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Vy7Ks","rootMobile":"styles_rootMobile__lNUKw"};